import React from "react";

const Fax = () => {
  return <div className="f-24 p-5 text-center">Under Construction </div>;
};

export default Fax;
